// import { useState } from "react";
// import { useEffect } from "react";
// import { Container, Navbar } from "react-bootstrap";
// import ScrollToActive from "../WebComponent/ScrollToActive";
// import NavigationMenu from "./NavigationMenu";

// export default function Header() {
//     const [headerClass, setHeaderClass] = useState('scroll-off');
//     const activeSection = ScrollToActive();

//     useEffect(() => {
//         const handleScroll = () => {
//             if (window.scrollY >= 10) {
//                 setHeaderClass('scroll-on');
//             } else {
//                 setHeaderClass('scroll-off');
//             }
//         };

//         window.addEventListener('scroll', handleScroll);

//         return () => {
//             window.removeEventListener('scroll', handleScroll);
//         };
//     }, []);

//     return(
//         <div className={`w-header ${headerClass}`}>
//             <Container>
//                 <Navbar expand="lg">
//                     <Navbar.Brand href="/">
//                         <img src="/logo/logo.png" alt="FieldCalc"/>
//                         <span>FieldCalc</span>
//                     </Navbar.Brand>
//                     <Navbar.Toggle aria-controls="navbarScroll" />
//                     <Navbar.Collapse id="navbarScroll">
//                         <NavigationMenu activeSection={activeSection} />
//                     </Navbar.Collapse>
//                     <div className='navbar-appbtn'>
//                         <a className="me-2" target="_blank" href="https://play.google.com/store/apps/details?id=com.voice.gps.navigation.map.location.route&hl=en_IN">
//                             <img src='/logo/playstore.svg' className='img-fluid' />
//                         </a>
//                         <a className="ms-2" target="_blank" href="https://apps.apple.com/us/app/gps-fields-area-measure-on-map/id1238984272">
//                             <img src='/logo/appstore.svg' className='img-fluid' />
//                         </a>
//                     </div>
//                 </Navbar>
//             </Container>
//         </div>
// )}

import { useState, useEffect } from "react";
import { Container, Navbar } from "react-bootstrap";
import ScrollToActive from "../WebComponent/ScrollToActive";
import NavigationMenu from "./NavigationMenu";
import "./Header.css"; // Import the CSS file
import { useLocation } from "react-router-dom";

export default function Header() {
  const [headerClass, setHeaderClass] = useState("scroll-off");
  const activeSection = ScrollToActive();
  const { pathname } = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY >= 10) {
        setHeaderClass("scroll-on");
      } else {
        setHeaderClass("scroll-off");
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div className={`w-header ${pathname==="/contact-us"?"transparent-header-contact-us":""} ${headerClass}`}>
      <Container>
        <Navbar expand="lg">
          <Navbar.Brand href="/">
            <img src="/logo/logo.png" alt="FieldCalc" />
            <span>FieldCalc</span>
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="navbarScroll" />
          <Navbar.Collapse id="navbarScroll">
            <NavigationMenu activeSection={activeSection} />
          </Navbar.Collapse>
          <div className="navbar-appbtn">
            <a
              className="me-2"
              target="_blank"
              rel="noopener noreferrer"
              href="https://play.google.com/store/apps/details?id=com.voice.gps.navigation.map.location.route&hl=en_IN"
            >
              <img
                src="/logo/playstore.svg"
                className="img-fluid"
                alt="Play Store"
              />
            </a>
            <a
              className="ms-2"
              target="_blank"
              rel="noopener noreferrer"
              href="https://apps.apple.com/us/app/gps-fields-area-measure-on-map/id1238984272"
            >
              <img
                src="/logo/appstore.svg"
                className="img-fluid"
                alt="App Store"
              />
            </a>
          </div>
        </Navbar>
      </Container>
    </div>
  );
}
